@if (mediaGroups.length > 0) {
  <div
    class="photo-list"
    infiniteScroll
    [scrollWindow]="false"
    [infiniteScrollDistance]="2"
    [infiniteScrollUpDistance]="1.5"
    [infiniteScrollThrottle]="50"
    (scrolled)="onNewScrollPosition()"
  >
    <div class="content">
      @for (group of mediaGroups; track group) {
        <div class="group">
          <div class="font-14">
            {{ group.date | date: "MMMM yyyy" }}
          </div>
          <div class="list row">
            @for (mediaContainer of group.photos; track mediaContainer) {
              @if (
                !hideVideos || mediaContainer.payload.mediaType !== "Video"
              ) {
                <div
                  #tile
                  data-testid="library-media-tile"
                  [attr.data-media-id]="mediaContainer.payload.id"
                  class="col-xs-12 col-sm-6 col-lg-4 col-xl-3 item"
                  [style.height.px]="tile.offsetWidth"
                >
                  <div class="grow-shadow card">
                    <app-media-details
                      [libItem]="mediaContainer"
                      (selected)="onSelected($event)"
                      [ownFile]="
                        userId === mediaContainer.payload.creator.userId
                      "
                      [type]="mediaContainer.payload.mediaType"
                      [disabled]="mediaContainer.payload.isExported ?? false"
                      [exported]="mediaContainer.payload.isExported ?? false"
                      [ignoreStateChange]="isMaxSelected"
                    ></app-media-details>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      }
      @if (loading && hasMore) {
        <div>
          <app-empty-state [isLoading]="true" [message]="'Loading Photos'">
          </app-empty-state>
        </div>
      }
      @if (!hasMore) {
        <div class="list-end">- That's all -</div>
      }
    </div>
  </div>
}
